import type { OrganizationMember } from './organizations';

/**
 * 탈퇴한 계정의 멤버인가 — 근거는 `user.deletedAt` 하나뿐이다.
 *
 * 계정 없는 멤버(외부 결재자·서명 참가자 등 `user` 없음)는 **탈퇴가 아니다** — 탈퇴할 계정이
 * 없다. 그래서 결재 담당자 후보에서 이 술어로 거를 때 계정 없는 사람은 남는다(S18 최소장).
 *
 * 멤버 관리 화면(탈퇴 배지·비활성 탭)과 결재 담당자 지정 후보(S17-c: 낡은 신원은 결재자로
 * 해석하지 않는다)가 **같은 술어**를 쓴다 — `GET /organizations/:id/members`는 탈퇴 계정을
 * 응답에서 빼지 않으므로(멤버 관리가 배지를 그려야 한다) 소비하는 쪽이 각자 걸러야 하고,
 * 술어가 두 벌이면 한쪽만 고쳐진다.
 *
 * ⚠️ 왜 `lib/organizations`가 아니라 별도 모듈인가: 그 모듈은 web spec 15곳이 `vi.mock`으로
 * 통째 대체한다(API 클라이언트라서). 순수 술어를 거기 두면 mock 팩토리가 이 export를 모르는
 * 모든 spec이 "No export is defined on the mock"으로 한꺼번에 깨진다(2026-08-29 merge 직후
 * 실제로 18건). 순수 술어는 mock 대상이 아닌 모듈에 산다.
 */
export function isWithdrawnMember(member: Pick<OrganizationMember, 'user'>): boolean {
  return Boolean(member.user?.deletedAt);
}
